import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=71cff476&scoped=true&"
import script from "./FormUpload.vue?vue&type=script&lang=js&"
export * from "./FormUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormUpload.vue?vue&type=style&index=0&id=71cff476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cff476",
  null
  
)

export default component.exports